export default __webpack_public_path__ + "static/media/i128hp.90e3bc4d.webp";